import createAffiliatePortalInstance from "../../api/AffiliatePortalInstance";
import { getPrivateInstance } from "../_privateInstance";

// Which auth context an analytics hook runs under. The operator tree uses
// the staff token (`getPrivateInstance`); the portal tree uses the
// affiliate's own AccessToken and routes scoped by that token.
export type AffiliateAnalyticsDataSource = "operator" | "portal";

export const getAnalyticsInstance = (
  dataSource: AffiliateAnalyticsDataSource,
) =>
  dataSource === "portal"
    ? createAffiliatePortalInstance()
    : getPrivateInstance();
